export default "__VITE_ASSET__2cbac058__"